const actionType = {
    setGlobalCursorHover: "SET_GLOBAL_CURSOR_HOVER",
    setGlobalBgColor: "SET_GLOBAL_BACKGROUND_COLOR",
    setProjectSharedLayout: "SET_PROJECT_SHARED_LAYOUT",
};

export default actionType;